// extracted by mini-css-extract-plugin
export var container = "styles-module--container--6Ay8y";
export var slide = "styles-module--slide--tO-+m";
export var present = "styles-module--present--26ghh";
export var future = "styles-module--future--uhrMx";
export var past = "styles-module--past--dmNCU";
export var dialog = "styles-module--dialog--5Tehe";
export var active = "styles-module--active--OPdHT";